import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import ViewHeader from '../components/ViewHeader';
import KpiCard from '../components/KpiCard';
import CategoryBar from '../components/CategoryBar';

const kpis = [
    { title: 'Total appointment', value: '120', change: '12%', changeType: 'up' },
    { title: 'Total outpatient Visit', value: '234', change: '9%', changeType: 'up' },
    { title: 'Total inpatient visit', value: '58', change: '9%', changeType: 'down' },
];

const appointmentTypes = [
    { label: 'Accommodation', value: 90 },
    { label: 'Dental care', value: 70 },
    { label: 'Emergency', value: 35 },
    { label: 'General consultation', value: 98 },
    { label: 'Home visit', value: 35 },
    { label: 'Lab test', value: 75 },
    { label: 'Medication', value: 20 },
    { label: 'Medical procedure', value: 75 },
    { label: 'Pet non medical services', value: 35 },
    { label: 'Surgery', value: 75 },
    { label: 'Telemedicine', value: 75 },
    { label: 'Follow up', value: 35 },
    { label: 'Vaccination', value: 80 },
    { label: 'Pet supplies and products', value: 40 },
];

const activityData = [
    { name: 'Jan', revenue: 32, visit: 43 },
    { name: 'Feb', revenue: 34, visit: 11 },
    { name: 'Mar', revenue: 21, visit: 23 },
    { name: 'Apr', revenue: 11, visit: 18 },
    { name: 'May', revenue: 32, visit: 43 },
    { name: 'Jun', revenue: 34, visit: 11 },
    { name: 'Jul', revenue: 21, visit: 23 },
    { name: 'Aug', revenue: 11, visit: 18 },
    { name: 'Sep', revenue: 22, visit: 12 },
    { name: 'Oct', revenue: 32, visit: 43 },
    { name: 'Nov', revenue: 23, visit: 33 },
    { name: 'Dec', revenue: 25, visit: 55 },
];

const occupancyData = [
    { label: 'Clinic Occupancy', value: 75 },
];

const ClinicalActivity = ({ onBack }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, minHeight: 0 }}>
            <ViewHeader title="Clinical Activity Overview" subtitle="March 2026" onBack={onBack} />

            <div style={{ display: 'flex', gap: '16px', flex: 1, minHeight: 0 }}>
                {/* Left column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, minHeight: 0 }}>
                    {/* Clinical activity summary */}
                    <div className="clinic-dashboard-section-card" style={{ animationDelay: '0ms' }}>
                        <div className="clinic-dashboard-section-title">Clinical activity summary</div>
                        <div className="clinic-dashboard-kpi-row">
                            {kpis.map((kpi, i) => <KpiCard key={i} {...kpi} />)}
                        </div>
                    </div>

                    {/* Activity over time */}
                    <div className="clinic-dashboard-section-card" style={{ flex: 1, minHeight: 0, animationDelay: '80ms' }}>
                        <div className="clinic-dashboard-section-title">Activity over time</div>
                        <div className="clinic-dashboard-chart-wrap" style={{ minHeight: '200px' }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart data={activityData} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                                    <XAxis
                                        dataKey="name"
                                        axisLine={false}
                                        tickLine={false}
                                        tick={{ fill: '#9ca3af', fontSize: 12 }}
                                    />
                                    <YAxis
                                        axisLine={false}
                                        tickLine={false}
                                        tick={{ fill: '#9ca3af', fontSize: 12 }}
                                    />
                                    <Tooltip
                                        contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                                    />
                                    <Legend
                                        verticalAlign="bottom"
                                        height={36}
                                        iconType="circle"
                                        iconSize={8}
                                        wrapperStyle={{ fontSize: '13px', color: '#4b5563' }}
                                    />
                                    <Line animationBegin={600} type="monotone" dataKey="revenue" stroke="#0f766e" strokeWidth={2} dot={{ r: 4, fill: '#0f766e' }} activeDot={{ r: 6 }} />
                                    <Line animationBegin={600} type="monotone" dataKey="visit" stroke="#f97316" strokeWidth={2} dot={{ r: 4, fill: '#f97316' }} activeDot={{ r: 6 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>

                {/* Right column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, minHeight: 0 }}>
                    {/* Appointment by type */}
                    <div className="clinic-dashboard-section-card" style={{ flex: 1, animationDelay: '160ms' }}>
                        <div className="clinic-dashboard-section-title">Appointment by type</div>
                        <div className="clinic-dashboard-catbar-list medium" style={{ justifyContent: 'center' }}>
                            {appointmentTypes.map((bar, i) => <CategoryBar key={i} {...bar} />)}
                        </div>
                    </div>

                    {/* Clinic Occupancy */}
                    <div className="clinic-dashboard-section-card" style={{ animationDelay: '240ms' }}>
                        <div className="clinic-dashboard-section-title">Clinic Occupancy</div>
                        <div className="clinic-dashboard-catbar-list large" style={{ justifyContent: 'center' }}>
                            {occupancyData.map((bar, i) => <CategoryBar key={i} {...bar} />)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClinicalActivity;
